import React, { PropsWithChildren } from 'react';
import NavBar from 'src/app/common/components/modules/NavBar/NavBar';
import styles from './ContainerNavBar.module.scss';

const ContainerNavBar: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles.container}>
      {children}
      <NavBar />
    </div>
  );
};

export default ContainerNavBar;
